import {FormInstance} from "antd";

export function getLang() {
    return document.cookie.split('; ').find(r => r.startsWith('lang'))?.split('=')[1]
}

export function setFormErrors(err: any, form: FormInstance) {
    if(err?.status === 400) {
        let errors: FieldError[] = err.data.data?.fieldErrors
        if(errors?.length > 0) {
            errors.forEach(({ field, error }) => {
                form.setFields([{name: field, errors:[error]}])
            });
        }
    }
}

export enum ResultCodeForCaptchaEnum {
    CaptchaIsRequired = 10
}
export type FieldError = {
    field: string
    error: string
}
export type APIResponseType<D = {}, RC = number> = {//ограничения D={}
    data: D
    message: string
    code: RC
}
export type NsiItem = {
    id: number
    code: number
    name: string
}
export type PageItems<D = {}> = {
    count: number
    page: number
    pageSize: number
    pageCount: number
    items: Array<D>
}
type MapItem = {
    [key: string]: string
}
export const maskMap: MapItem = {
    be: "DD.MM.YYYY",
    ru: "DD.MM.YYYY",
    en: "MM/DD/YYYY"
};